export enum ESlots {
  Start = 'start',
  End = 'end',
  IconOnly = 'icon-only',
  None = ''
}
